export default __webpack_public_path__ + "static/media/icon-email-decline.458df4c9.svg";